<template>
  <div class="page-menu">
    <ul :class="classes">
      <li v-for="(item, index) in items" :key="index" class="page-menu__list__item">
        <m4-button :href="item.link" variant="primary-text" tag="a" class="page-menu__list__item__btn">
          {{ item.title }}
        </m4-button>
      </li>
      <li
        v-for="(slotItem, index) in slotItems"
        :key="index + (items ? items.length : 0)"
        class="page-menu__list__item"
      >
        <m4-button v-bind="slotItem.props" class="page-menu__list__item__btn">
          {{ slotItem.title }}
        </m4-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "M4PageMenu",
  data() {
    return {};
  },
  props: {
    items: Array,
    top: Boolean,
    bottom: Boolean
  },
  computed: {
    classes() {
      let classes = ["page-menu__list"];
      if (this.top) {
        classes.push("page-menu__list--top");
      }
      if (this.bottom) {
        classes.push("page-menu__list--bottom");
      }
      return classes;
    },
    slotItems() {
      let items = [];
      if (this.$slots.default) {
        const defaultSlots = this.$slots.default();
        defaultSlots.forEach((sItem) => {
          const sItemSlot = sItem.children.default();
          if (sItemSlot[0] !== undefined) {
            items.push({
              props: sItem.props,
              title: typeof sItemSlot[0].children === "string" ? sItemSlot[0].children : "undefined"
            });
          }
        });
      }
      return items;
    }
  },

  methods: {}
};
</script>
